<popup-modal [openModal]="openModal" (onClose)="closeForm()">
  <div class="support-form">
    <span class="support-form_title">Need help?</span>
  
    <span class="support-form_tooltip">
      Send a message to our support team,<br/> and we'll get back to you via email<br/> shortly.
    </span>
  
    <span class="support-form_section-title">Your Details:</span>
    <input-field 
      [format]="userNameType"
      label="Name"
      [(value)]="username"
      [readonly]="prefill && !!username.length"
      [isError]="invalidUserName"
    ></input-field>
    <input-field 
      [format]="emailType"
      label="Email"
      [(value)]="email"
      [readonly]="prefill && !!email.length"
      [isError]="invalidEmali"
    ></input-field>
    <input-field 
      [format]="apartmentsType"
      label="Apartment"
      [(value)]="apartments"
      [isError]="invalidApartments"
    ></input-field>

    <dropdown-list
      placeholder="Building"
      [(value)]="building"
      [values]="buildingsList"
      [error]="invalidBuilding"
    ></dropdown-list>
  
    <span class="support-form_section-title">Your Message:</span>
    <div class="support-form_message" [ngClass]="{ 'error': invalidMessageText }"> 
      <ion-textarea
        class="message-text"
        [autoGrow]="true"
        [(ngModel)]="messageText"
      >
      </ion-textarea>
    </div>
    <ion-button class="solid" type="submit" (click)="sendMessage()">Send</ion-button>
  </div>
</popup-modal>

